import CrossIcon from '../../../../icons/CrossIcon'
import Text from '../../../../Text'
import Modal from '../../../../Modal'
import React from 'react'
import { useUiStore } from '../../../../../store/uiStore'
import styles from './styles.module.css'
import CtaV2 from '../../../../CtaV2'
import CartIcon from '../../../../icons/CartIcon'
import { $preOrder } from '../../../../../styles/colors/semantics'

function PreOrderWarningModal({ onAddToCart }) {
  // The pre-order modal flag + payload moved off Overmind to the Zustand ui store
  // (Phase C2 part 1). closePreOrderWarning mirrors actions.closePreOrderWarningModal.
  const showPreOrderWarningModal = useUiStore((s) => s.showPreOrderWarningModal)
  const preOrderWarning = useUiStore((s) => s.preOrderWarning)
  const closePreOrderWarning = useUiStore((s) => s.closePreOrderWarning)

  return (
    <Modal show={showPreOrderWarningModal} onClose={() => closePreOrderWarning()}>
      <div className={styles.modalWrapper}>
        <button className={styles.closeButton} onClick={() => closePreOrderWarning()}>
          <CrossIcon/>
        </button>
        <Text type="heading-6">Pre-order</Text>
        <Text type="medium">{preOrderWarning.itemWarningText}</Text>
        <div className={styles.modalCtas}>
          <CtaV2 title="Cancel" light onClick={() => closePreOrderWarning()}/>
          <CtaV2 title="Pre-order"
                 titleIcon={<CartIcon large/>}
                 sx={{
                   background: $preOrder,
                 }}
                 onClick={onAddToCart}/>
        </div>
      </div>
    </Modal>
  )
}

export default PreOrderWarningModal
